
import React, { FC } from "react";
import { UserSeries } from "redux/state";
import { Users } from "./Users";

export interface UsersContainerProps {
    readonly appId: string;
    readonly organizationId: string;
}

export const emptyUserSeries: UserSeries = {
    intervals: [],
    total: {
        newUsers: undefined,
        returningUsers: undefined,
        totalSessions: undefined,
        totalUsers: undefined
    }
};

export const UsersContainer: FC<UsersContainerProps> = ({ appId, organizationId }: UsersContainerProps) => {
    return (
        <Users
            appId={appId}
            organizationId={organizationId}
        />
    );
};

